

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}

jQuery(document).ready(function($){

	console.log('z');


/*
	$("#contentLeft").corner("#E6DED0 20px");
	$("#contentRight").corner("#E6DED0 20px");
*/
	
	//suchformular an/aus
 	$("#searchContainer").click(function() {
		$("#search_form").fadeIn(300);
	});
	
	$("#searchContainer").mouseleave(function() {
		if($("#acRes").html()=="")
			$("#search_form").fadeOut(700);
	});


  $('.close-popup').click(function() {
    $(".popup").fadeOut(300);
    //document.cookie = "popupaccepted=true";
    //setCookie('popupaccepted','true',7);
  });

  var x = getCookie('popupaccepted');
  if (x) {
     // $(".popup").hide();
  }
	
	//bildergalerie
	if($("a.imgGallery").length>0)
		$("a.imgGallery").fancybox({
			'transitionIn'	:	'fade',
			'transitionOut'	:	'fade',
			'speedIn'	:	600, 
			'speedOut'	:	200, 
			'overlayShow'	:	false,
			'cyclic'	:	true,
			'overlayOpacity':	0.5,
			'overlayColor'	:	'#fff',
			'overlayShow'	:	true,
			'titleShow'	:	true
		});
		
	if($("a.linkGallery").length>0)
		$("a.linkGallery").fancybox({
			'width'		: '60%',
			'height'	: '60%',
        		'autoScale'    	: false,
        		'transitionIn'	: 'none',
			'transitionOut'	: 'none',
			'type'		: 'iframe'
		});
	
	// Volltextsuche
	 
   var requestInAction=false;
   var activeRes = 0;
   var maxRes = 10;
   var iRes = -1;

	function refreshResultsCss(inputId){
		$(".r").each(function(index) {
			$(this).removeClass("r rActive").addClass("r");
		});        	
		document.getElementById(activeRes).className="r rActive";
		document.getElementById(inputId).value=document.getElementById(activeRes).innerHTML.replace("<b>","").replace("</b>","");	
	}
   
// Autocomplete
   $("#search_form input[name*=query]").keyup(function(event) {
	var inputId = this.id;
	var acContainerId = "acRes"; 
	var submitformId = "searchform";
   	var keyId = event.keyCode;
   	
   	var key = this.value;
   	var res = "";

   	if(keyId>36 && keyId<41 && iRes > -1){
       	if(keyId==40 && activeRes<iRes){
       		activeRes++;
       		refreshResultsCss(inputId);
       	}else if(keyId==38 && activeRes>0){
		activeRes--;
		refreshResultsCss(inputId);
       	}
       	
       }else if(key!=null && key!="" && key.length>2){

   		// zusaetzliche Steuerfunktion? 
   		// wenn waehrend des Delays eine Eingabe getaetigt wird, wird keine Anfrage gesendet. Auch nicht nach Ablauf des Delays. Dies erfordert eine ernuete eingabe des Begriffs.
   		if(requestInAction==false){			
   				
   				requestInAction=true;
   				var sqlUrl=searchAutoComplete+"?results=10&query="+key;	
   				
   				$.ajax({				
   					  url: sqlUrl,		  		  
   					  cache: false,
   					  success: function(html){
   						res=html;					
	   					var out = "";
   						var results = res.getElementsByTagName("result");
   						iRes = (results.length-1);
   						for(var i=0;i<results.length;i++){
   							
   							var match = results[i].getElementsByTagName("title")[0].childNodes[0].nodeValue;
   							var lMatch = match.toLowerCase();
   							var lKey = key.toLowerCase();
   							var posKeyStart = lMatch.indexOf(lKey);
   							var posKeyEnde = posKeyStart+lKey.length;
   							
   							var matchPart1 = match.substring(0,posKeyStart);
   							var matchPart2 = match.substring(posKeyStart,posKeyEnde);
   							var matchPart3 = match.substring(posKeyEnde,match.length);
   							out+="<div class='r' id='"+i+"'>"+matchPart1+"<b>"+matchPart2+"</b>"+matchPart3+"</div>";
   						}
   						document.getElementById(acContainerId).innerHTML=out;
   						if(out=="")
   							resetAcResult();					
   						
   						// erst ab hier sind die divs vorhanden und kann von jquery gefunden werden. wird die funktion vorher eingebunden, sind die divs fï¿½r jquery nicht vorhanden.   						
   						$("div.r").mousedown(function () {
   							var val = this.innerHTML;
   							val=val.replace("<b>","");
   							val=val.replace("</b>","");
   							document.getElementById(inputId).value=val;
   							resetAcResult();	
   							//document.searchForm.submit();
   							document.getElementById(submitformId).submit();
   						});
   						
   						requestInAction=false;
   						$("#acRes").show();	
					
   					  },
   				  	  error: function(html){
   						res="ERROR";
   						document.getElementById(acContainerId).innerHTML=res;
   						requestInAction=false;					
   					  }		  
   				});				
   			}
   		
   		}else{
   			resetAcResult();
   		}
   	
   	
   });	
   $("#search_form input[name*=query]").blur(function(event) {
   	$("#acRes").hide();
   });	
   $("#search_form input[name*=query]").focus(function(event) {
   	if($("#acRes").html()!="")$("#acRes").show();
   });   
   
   function resetAcResult(){
 	 $("#acRes").html("");
   }	
	
});

/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
}); 